<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
// eslint-disable-next-line import/extensions, import/no-unresolved
import { mount, unmount } from 'gwReact/gw-react-plumbing'

const rootElement = ref<HTMLDivElement | null>(null)
let reactRoot: unknown

onMounted(() => {
  reactRoot = mount(rootElement.value)
})

onBeforeUnmount(() => {
  unmount(reactRoot)
})
</script>
<template>
  <div
    id="gw-react-wrapper"
    ref="rootElement"
    style="display: none"
  />
</template>
